import { useEffect, useState } from 'react';
export function useResizeObserver<T extends HTMLElement = HTMLElement>(ref: React.RefObject<T>) {
  const [contentRect, setContentRect] = useState<DOMRectReadOnly | null>(null);
  useEffect(() => {
    if (!ref.current) {
      return;
    }
    const handleResize: ResizeObserverCallback = entries => {
      for (const entry of entries) {
        setContentRect(entry.contentRect);
      }
    };
    const observer = new ResizeObserver(handleResize);
    observer.observe(ref.current);
    return () => {
      observer.disconnect();
    };
  }, [ref]);
  return contentRect;
}